import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { ISO_DATE_FORMAT, INTL_SHORT_DAY_NAME_DAY_MONTH, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import AIGlowSummaryShell from 'components/Common/AIGlowSummaryShell'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { useContext } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  /**
   * @default day
   */
  timeUnit?: 'day' | 'night'
  // TODO: This prop has been carried over from the old `SearchDateFooter`.
  // Needs more justification by the Cruises team.
  includeLastDayOnCount?: boolean
}

function FormattedSearchDate(props: Props) {
  const { timeUnit = 'night', includeLastDayOnCount } = props
  const { checkinDate, checkoutDate } = useContext(GlobalSearchStateContext)
  const intl = useIntl()

  const hasDates = !!(checkinDate && checkoutDate)

  if (!hasDates) return null

  const count = checkoutDate.diff(checkinDate, 'days') + (includeLastDayOnCount ? 1 : 0)
  const durationText = timeUnit === 'night'
    ? intl.formatMessage({
        id: 'my-fCJp68IVHhDbo3_t6',
        defaultMessage: '({count, plural, one {# night} other {# nights}})',
      }, { count })
    : intl.formatMessage({
        id: 'MZD8RZgP-ONMy2c3qHNw',
        defaultMessage: '({count, plural, one {# day} other {# days}})',
      }, { count })

  return <AIGlowSummaryShell data-testid="search-date-summary" glowTestId="date-summary-glow">
    <Group direction="horizontal" gap={8} verticalAlign="center">
      <Group direction="horizontal" gap={4} verticalAlign="center">
        <BodyText variant="medium" weight="bold">
          <time dateTime={checkinDate.format(ISO_DATE_FORMAT)}>
            {intlDateFormatter(checkinDate, INTL_SHORT_DAY_NAME_DAY_MONTH, intl.locale)}
          </time>
        </BodyText>

        <LineArrowRightIcon size="S" />

        <BodyText variant="medium" weight="bold">
          <time dateTime={checkoutDate.format(ISO_DATE_FORMAT)}>
            {intlDateFormatter(checkoutDate, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale)}
          </time>
        </BodyText>
      </Group>

      <BodyText variant="medium">
        {durationText}
      </BodyText>
    </Group>
  </AIGlowSummaryShell>
}

export default FormattedSearchDate
